<sc-padding fitHeight>
  <sc-flex vertical stretchContent fitHeight>
    <div>
      <sc-items-grid [width]="120" [gap]="16">
        @for (resource of transportOption?.resources; track resource) {
          <ac-resource-image-thumbnail (click)="selectResource(resource)" [resourceId]="resource">{{resource}}</ac-resource-image-thumbnail>
        }
      </sc-items-grid>
    </div>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <ac-resource-image-view withControls [resourceId]="currentResourceId" (deleteClicked)="handleDeleteClicked()"></ac-resource-image-view>
    </sc-flex-fitting-content>
    <sc-content-spacer vertical></sc-content-spacer>
    <div>
      <sc-flex [centered]="true">
        <ac-resource-upload (uploaded)="handleUpadedResource($event)" usage="transport_option"></ac-resource-upload>
      </sc-flex>
    </div>
  </sc-flex>
</sc-padding>
